import React, {
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { DataContext } from "../context/DataContext";
import NoImage from "../images/no-image.png";
function ShareuserIcons({ folderId, envId, env_subfolder }) {
  const { getFolderAccessList, getEnvAccessList } =
    useContext(DataContext);
  const count = useRef(0);

  const [folderAccessList, setFolderAccessList] = useState([]);
  const [envAccessList, setEnvAccessList] = useState([]);

  const listIcons = async (id) => {
    const icons = await getFolderAccessList(id || "");
    setFolderAccessList(icons);
  };

  const listEnvIcons = async (eid, fid) => {
    const icons = await getEnvAccessList(eid || "", fid || "");
    setFolderAccessList(icons?.folderAccess || []);
    setEnvAccessList(icons?.envAccess || []);
    // console.log(icons, "iooo");
  };

  useEffect(() => {
    if (env_subfolder) {
      listEnvIcons(envId, folderId);
    } else listIcons(folderId);

    // console.log(folderId, envId);
  }, [folderId, envId]);

  return (
    <div className="shareUserPan">
      <ul>
        {count.current > 5 ? <li className="text">5+</li> : null}
        {envAccessList?.map((item, index) => {
          if (count.current < 6)
            return (
              <li key={index + "fal"}>
                <img
                  className="userImg memberIcon "
                  src={item?.profilePhoto || NoImage}
                  alt="user"
                  referrerPolicy="no-referrer"
                />
              </li>
            );
          count.current = count.current + 1;
        })}
        {folderAccessList?.map((item, index) => {
          if (count.current < 6)
            return (
              <li key={index + "fal"}>
                <img
                  className="userImg memberIcon "
                  src={item?.profilePhoto || NoImage}
                  alt="user"
                  referrerPolicy="no-referrer"
                />
              </li>
            );
          count.current = count.current + 1;
        })}
      </ul>
    </div>
  );
}

export default ShareuserIcons;
